// WIJAYA_CUSTOM_START erp_lead_sidebar
export const STATUS_OPTIONS = [
  'Lead',
  'Qualified',
  'Catalogue Request',
  'Sample Request',
  'Converted',
  'Regular Customer',
  'Lost Quotation',
];

export const MARKET_CUSTOMER_OPTIONS = [
  ['Brand Sendiri', 'custom_brand_sendiri'],
  ['OEM Brand', 'custom_oem_brand'],
  ['OEM Non Brand', 'custom_oem_non_brand'],
  ['Online Store', 'custom_online_store'],
  ['Distribusi Kain', 'custom_distribusi_kain'],
  ['Retail Kain', 'custom_retail_kain'],
  ['Tailor', 'custom_tailor'],
  ['Wedding', 'custom_wedding'],
  ['Sekolah', 'custom_sekolah'],
  ['Instansi Pemerintahan', 'custom_instansi_pemerintahan'],
];

export const JENIS_PAKAIAN_OPTIONS = [
  ['Gamis', 'custom_gamis'],
  ['Dress', 'custom_dress'],
  ['T-Shirt', 'custom_tshirt'],
  ['Kemeja', 'custom_kemeja'],
  ['Celana Pria', 'custom_celana_pria'],
  ['Celana Wanita', 'custom_celana_wanita'],
  ['Jaket', 'custom_jaket'],
  ['Sweater / Hoody', 'custom_sweater__hoody'],
  ['Seragam Sekolah', 'custom_seragam_sekolah'],
  ['Jas', 'custom_jas'],
  ['Gaun Pengantin', 'custom_gaun_pengantin'],
  ['Kaus Kaki', 'custom_kaus_kaki'],
  ['Seragam Kantor', 'custom_seragam_kantor'],
  ['Seragam Pemerintahan', 'custom_seragam_pemerintahan'],
  ['Kebaya', 'custom_kebaya'],
  ['Sport', 'custom_sport'],
  ['Piyama', 'custom_piyama'],
  ['Lingeri', 'custom_lingeri'],
  ['Pakaian Anak', 'custom_pakaian_anak'],
  ['Pakaian Bayi', 'custom_pakaian_bayi'],
  ['Pakaian Dalam', 'custom_pakaian_dalam'],
  ['Batik', 'custom_batik'],
  ['Jeans', 'custom_jeans'],
  ['Hijab', 'custom_hijab'],
];
// WIJAYA_CUSTOM_END erp_lead_sidebar
